import { useEffect } from "react";
import ReactGA from "react-ga4";
import { Location } from "react-router-dom";

interface GAListenerProps {
  children: React.ReactNode;
  location: Location;
}

const GAListener:React.FC<GAListenerProps> = ({ 
  children, 
  location, 
}): React.ReactElement => {
  
  useEffect(() => {
    ReactGA.set({ page: location.pathname + location.search });
    ReactGA.send({
      hitType: "pageview",
      page: location.pathname + location.search,
    });
  }, [location]);

  return <>{children}</>;
};

export default GAListener;
